import clsx from "clsx";
import format from "date-fns/format";
import isValid from "date-fns/isValid";
import isSameDay from "date-fns/isSameDay";
import endOfWeek from "date-fns/endOfWeek";
import React, { PureComponent } from "react";
import startOfWeek from "date-fns/startOfWeek";
import isWithinInterval from "date-fns/isWithinInterval";

import LocalizationProvider from '@mui/lab/LocalizationProvider';
// this guy required only on the docs site to work with dynamic date library
import { makeJSDateObject } from "../../lib/helper";
import { IconButton } from "@mui/material";
import DateFnsUtils from "@date-io/date-fns";
import moment from 'moment';


class WeekPickers extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            selectedDate: new Date(),
          };
    }
    
  componentDidMount(){
    this.handleWeekChange(this.state.selectedDate)
  }

  handleWeekChange = date => {
    this.setState({ selectedDate: startOfWeek(makeJSDateObject(date)) });
    const week = startOfWeek(makeJSDateObject(date))
    const data = {
        startDate: moment(week).startOf('week').toDate().valueOf(),
        endDate: moment(week).endOf('week').toDate().valueOf(),
        week: week
      }
    this.props.handleChange?.(data)
  };

  formatWeekSelectLabel = (date, invalidLabel) => {
    let dateClone = makeJSDateObject(date);

    return dateClone && isValid(dateClone)
      ? `Week of ${format(startOfWeek(dateClone), "MMM do")}`
      : invalidLabel;
  };

  renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth) => {
    const { classes } = this.props;
    let dateClone = makeJSDateObject(date);
    let selectedDateClone = makeJSDateObject(selectedDate);

    const start = startOfWeek(selectedDateClone);
    const end = endOfWeek(selectedDateClone);

    const dayIsBetween = isWithinInterval(dateClone, { start, end });
    const isFirstDay = isSameDay(dateClone, start);
    const isLastDay = isSameDay(dateClone, end);

    const wrapperClassName = clsx({
      [classes.highlight]: dayIsBetween,
      [classes.firstHighlight]: isFirstDay,
      [classes.endHighlight]: isLastDay,
    });

    const dayClassName = clsx(classes.day, {
      [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
      [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween,
    });

    return (
      <div className={wrapperClassName}>
        <IconButton className={dayClassName}>
          <span> {format(dateClone, "d")} </span>
        </IconButton>
      </div>
    );
  };

  render() {
    const { selectedDate } = this.state;

    return (
        <React.Fragment>
            <LocalizationProvider AdapterDateFns={DateFnsUtils}>
                <DatePicker
                    autoOk
                    // disablePast
                    // clearable
                    // disableFuture
                    inputVariant="outlined"
                    inputMode="none"
                    id="date-picker-dialog"
                    // label="Week picker"
                    value={selectedDate}
                    onChange={this.handleWeekChange}
                    renderDay={this.renderWrappedWeekDay}
                    labelFunc={this.formatWeekSelectLabel}
                    className="datepicker"
                    placeholder="Week picker"
                    orientation="portrait"
                    minDate={new Date('04/11/2021')}
                    maxDate={new Date()}
                />
            </LocalizationProvider>
            <style jsx="true">{`
                .datepicker > div{
                    height: 38px;
                    color: ${this.props?.color}
                }
                `}</style>
      </React.Fragment>
    );
  }
}

export default WeekPickers;
